import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DimensionSelector from '../components/DimensionSelector';
import { checkVerificationStatus, cleanupExpiredVerification } from '../services/codeVerification';
import { statsStorage, localSettings } from '../services/persistentStorage';

const BigFivePersonalityTest: React.FC = () => {
  const navigate = useNavigate();
  const [hasValidAccess, setHasValidAccess] = useState(false);
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      try {
        // 检查是否为开放模式
        const isOpenMode = await localSettings.getTestModeOpen('big-five-personality');
        
        if (isOpenMode) {
          console.log('开放模式已启用，直接允许访问');
          setHasValidAccess(true);
        } else {
          // 非开放模式，需要验证测试码
          // 首先清理过期的验证状态
          await cleanupExpiredVerification('big-five-personality');
          
          // 检查验证状态
          const verificationStatus = checkVerificationStatus('big-five-personality');
          
          if (!verificationStatus.isVerified || verificationStatus.isExpired) {
            console.log('验证状态无效或已过期，重定向到测试码输入页面');
            navigate('/test-code?type=big-five-personality', { replace: true });
            return;
          }
          
          console.log('访问权限验证通过');
          setHasValidAccess(true);
        }
        
        // 记录进入测评次数
        try {
          await statsStorage.recordTestEntry('big-five-personality');
          console.log('已记录进入大五人格测评');
        } catch (error) {
          console.error('记录进入测评失败:', error);
        }
        
      } catch (error) {
        console.error('检查访问权限失败:', error);
        navigate('/test-code?type=big-five-personality', { replace: true });
      } finally {
        setIsCheckingAccess(false);
      }
    };

    checkAccess();
  }, [navigate]);

  if (isCheckingAccess) {
    return (
      <div className="min-h-screen bg-[#3A7D78] flex items-center justify-center">
        <div className="text-white text-lg">验证访问权限中...</div>
      </div>
    );
  }

  if (!hasValidAccess) {
    return null;
  }

  return (
    <div className="min-h-screen">
      <DimensionSelector />
    </div>
  );
};

export default BigFivePersonalityTest;